import type { HtPatient } from "../../../components/pages/patientHt/UpdateEmailAddressPage";

import { useState } from "react";
import { useLocation, useNavigate, Location } from "react-router";
import { useQuery } from "@apollo/client/react";
import { closeModal } from "../../../graphql/local-mutations";

import { PUBLISH_HT_VERIFY_CODE } from "../../../graphql/mutations";
import { GQLMutation } from "@rx-cs-system/schema";
import { useMutation } from "@apollo/client/react";
import { useSnackBar } from "../../../hooks/useSnackBar";
import { PublishVerifyCodePage as Component } from "../../../components/pages/patientHt/PublishVerifyCodePage";
import { GET_MODAL_STATE } from "../../../graphql/queries";
import { LocalQuery } from "../../../cache";
import { useCheckUserRole } from "../../../hooks/useCheckUserRole";

export const PublishVerifyCodePage = () => {
  const navigate = useNavigate();
  const location: Location<HtPatient> = useLocation();
  const htPatient = location.state;

  useCheckUserRole();

  const [verifyCode, setVerifyCode] = useState("");
  const [permanent, setPermanent] = useState(false);

  const { snackBar, showOKSnackBar, showErrorSnackBar } = useSnackBar();

  const [publishVerifyCode, { loading }] = useMutation<GQLMutation>(
    PUBLISH_HT_VERIFY_CODE,
    {
      onCompleted: () => {
        showOKSnackBar("確認番号の発行しました。");
        closeModal("confirmVerifyCode");
      },
      onError: () => {
        showErrorSnackBar(
          "確認番号の発行に失敗しました。DTFのチームにお問い合わせください。",
        );
        closeModal("confirmVerifyCode");
      },
    },
  );

  const { data: modalData } = useQuery<LocalQuery>(GET_MODAL_STATE);
  const confirmVerifyCodeModalOpened =
    modalData?.modalState.confirmVerifyCode.isOpen || false;

  const onCancelClick = () => navigate(`/patient_ht/${htPatient.id}`);

  const onPublishVerifyCodeClick = () => {
    publishVerifyCode({
      variables: {
        input: {
          id: htPatient.id,
          code: verifyCode,
          permanent,
        },
      },
    });
  };

  return (
    <Component
      setVerifyCode={setVerifyCode}
      setPermanent={setPermanent}
      verifyCode={verifyCode}
      permanent={permanent}
      snackBar={snackBar}
      isLoading={loading}
      confirmVerifyCodeModalOpened={confirmVerifyCodeModalOpened}
      onCancelClick={onCancelClick}
      onPublishVerifyCodeClick={onPublishVerifyCodeClick}
    />
  );
};
